module.exports = __webpack_public_path__ + "img/bgc1.c2c50c40.png";